import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { Card, Col, Row, Accordion, Form, Modal,Button } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import ReactLoading from 'react-loading'
import { myFirestore } from '../../services/firebase'
import images from '../../Themes/Images'
import ChatBoard from './../../components/PeerChat/ChatBoard/ChatBoard'
import ListGroup from 'react-bootstrap/ListGroup'
import './PeerChat.css'
class PeerChat extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: true,
            isOpenDialogConfirmLogout: false,
            currentPeerUser: null,
            auth: this.props.auth,
            profile: null,
            intakeformdetails: null,
            showFeedback: false,
            validated:false,
            feedback:null,
        }
       
        this.showIntakeForm3 = false;

        this.profile = null;
        this.currentUserId = this.state.auth.uid;
        this.currentUserAvatar = images.ic_default_avatar;
        

        


    }

    componentDidMount() {
        if (this.state.auth.uid != null) {

            this.getListUser()
        }

    }
    




    getListUser = async () => {
        const that = this;
        console.log(this.state.profile);
        myFirestore.collection("users").doc(this.state.auth.uid).onSnapshot(function (doc) {
            console.log("Current data: ", doc.data());
            that.setState({ profile: doc.data() })
            if (doc.data().isCounselor) {
                if (doc.data().nowCounseling !== '' && doc.data().nowCounseling !== doc.data().id) {
                    myFirestore.collection("users").doc(doc.data().nowCounseling).get().then(function (docs) {
                        if (docs.exists) {
                            console.log("Peer data:", docs.data());

                            that.setState({
                                currentPeerUser: docs.data(),
                                isLoading: false
                            })
                            that.loadIntakeForm()
                        } else {
                            // doc.data() will be undefined in this case
                            console.log("No such document!");
                        }
                    }).catch(function (error) {
                        console.log("Error getting document:", error);
                    });
                }
                else {
                    if (that.state.currentPeerUser) {
                        that.props.showToast(1, 'Session Ended')

                    }
                    that.setState({
                        currentPeerUser: null,
                        isLoading: true
                    })

                }




            }
            else {
                myFirestore.collection('users').where("isCounselor", "==", true).where("isAvailable", "==", true).limit(1).get()
                    .then(function (querySnapshot) {
                        querySnapshot.forEach(function (doc) {
                            // doc.data() is never undefined for query doc snapshots
                            console.log(doc.id, " => ", doc.data());
                            that.setState({ currentPeerUser: doc.data() })
                            myFirestore.collection('users')
                                .doc(doc.data().id)
                                .set({
                                    isAvailable: false,
                                    nowCounseling: that.state.auth.uid,
                                },
                                    { merge: true })
                                .then(() => {

                                    that.setState({ isLoading: false })
                                })
                                .catch(err => {
                                    that.setState({ isLoading: false })
                                    that.props.showToast(0, err.toString())
                                })
                        });
                    })
                    .catch(function (error) {
                        console.log("Error getting documents: ", error);
                        that.setState({ isLoading: false })
                        that.props.showToast(0, error.toString())
                    });


            }
        });




    }

    onStopSession = () => {
        this.setState({
            isOpenDialogConfirmLogout: true
        })
    }
    endSession = () => {
        this.setState({showFeedback:true});

        

    }

    doStopSession = () => {
        this.setState({ isLoading: true })
        myFirestore.collection('users')
            .doc(this.state.auth.uid)
            .set({
                isAvailable: false,
                nowCounseling: '',
            },
                { merge: true })
            .then(() => {


                this.props.showToast(1, 'Session Ended')
                this.props.history.push('/')
            })
            .catch(err => {
                this.setState({ isLoading: false })
                this.props.showToast(0, err.toString())
            })
    }
    doEndSessionForCounselor = () => {
        this.setState({ isLoading: true })
        myFirestore.collection('users')
            .doc(this.state.auth.uid)
            .set({
                isAvailable: true,
                nowCounseling: '',
            },
                { merge: true })
            .then(() => {


                this.props.showToast(1, 'Session Ended')

                this.props.history.push('/peerchat')

            })
            .catch(err => {
                this.setState({ isLoading: false })
                this.props.showToast(0, err.toString())
                console.log(err.toString())
            })
    }

    hideDialogConfirmLogout = () => {
        this.setState({
            isOpenDialogConfirmLogout: false
        })
    }
    loadIntakeForm = () => {

        let that = this
        myFirestore.collection("intakeform1").doc(this.state.currentPeerUser.id).get().then(function (doc) {
            if (doc.exists) {
                that.setState({
                    intakeformdetails: doc.data()
                })
                console.log("Document data:", that.state.intakeformdetails);
            } else {
                // doc.data() will be undefined in this case
                console.log("No such document!");
            }
        }).catch(function (error) {
            console.log("Error getting document:", error);
        })
    }
    updateUserData = () => {
        console.log(this.state.currentPeerUser)
        myFirestore.collection('users')
            .doc(this.state.currentPeerUser.id)
            .set({
                showIntakeForm3: this.showIntakeForm3,

            },
                { merge: true })
            .then(() => {

            })
            .catch(err => {
                console.log(err.toString())
            })

    }

    renderUserDetails = () => {
        return (<ListGroup >


            <ListGroup.Item>
                <b> Username: </b>{this.state.currentPeerUser.username}
            </ListGroup.Item>
            <ListGroup.Item>
                <b> Gender: </b>{this.state.currentPeerUser.gender}
            </ListGroup.Item>
            <ListGroup.Item>
                <b> Education qualification: </b>{this.state.currentPeerUser.qualification}
            </ListGroup.Item>
            <ListGroup.Item>
                <b> Occupation: </b>{this.state.currentPeerUser.occupation}
            </ListGroup.Item>
            <ListGroup.Item>
                <b> Family Members: </b>{this.state.currentPeerUser.familymembers}
            </ListGroup.Item>
            <ListGroup.Item>
                <b> Relationship Status: </b>{this.state.currentPeerUser.relationshipstatus}
            </ListGroup.Item>
            <ListGroup.Item>
                <b> Current living situation: </b>{this.state.currentPeerUser.livingsituation}
            </ListGroup.Item>
            <ListGroup.Item>
                <b> Currently living with: </b>{this.state.currentPeerUser.livingwith}
            </ListGroup.Item>
            <ListGroup.Item>
                <b> Is this your first time seeking therapy or counselling services? : </b>{this.state.currentPeerUser.isFirsttime}
            </ListGroup.Item>

            <ListGroup.Item>
                <b> List down the type of therapy you have tried out in the past: </b>{this.state.currentPeerUser.listofpasttherapy}
            </ListGroup.Item>
            <ListGroup.Item>
                <b> Age: </b>{this.state.currentPeerUser.age}
            </ListGroup.Item>





        </ListGroup>
        );

    }
    renderUserIntakeForm1 = () => {
        return (

            <ListGroup >

                <ListGroup.Item>

                    <b> What are the current issues for which you are seeking peer support? </b><br />{this.state.intakeformdetails.currentIssues}
                </ListGroup.Item>
                <ListGroup.Item>
                    <b>What are your treatment goals? </b> <br />{this.state.intakeformdetails.treatmentGoals}
                </ListGroup.Item>
                <ListGroup.Item>
                    <b> Current Symptoms list: </b>{this.state.intakeformdetails.symptoms.map(ele => { return <li>{ele}</li> })}
                </ListGroup.Item>



            </ListGroup>
        );

    }
    toggleshowform = () => {
        this.showIntakeForm3 = !this.showIntakeForm3;
        console.log('value:', this.showIntakeForm3)
        this.updateUserData();
    }
    handleSubmit=(event)=>{
        const form = event.currentTarget;
        
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
            
            
        
          }
          event.preventDefault();
          this.setState({
            validated:true
        })
      
          
          myFirestore.collection('users')
            .doc(this.state.currentPeerUser.id)
            .set({
                
                nowCounseling: '',
            },
                { merge: true })
            .then(() => {
                this.storefeedback();
                
                
            })
            .catch(err => {
                this.setState({ isLoading: false })
                this.props.showToast(0, err.toString())
            })
        
        
            
          
          
          
       
    }
    storefeedback=()=>{
        myFirestore.collection('feedbackform')
                        .doc(this.state.auth.uid)
                        .set({
                            feedback: this.state.feedback,
                            
                            
                        },
                            { merge: true })
                        .then(() => {

                            this.setState({ isLoading: false })
                            this.props.showToast(1, 'Session Ended')
                            if(this.props.profile.showIntakeForm3)
                            {
                                this.props.history.push('/intakeform3')
                            }
                            else{
                            this.props.history.push('/')
                            }
                        })
                        .catch(err => {
                            this.setState({ isLoading: false })
                            this.props.showToast(0, err.toString())
                        })
    }
    handleChange = (e) => {
        this.setState({
          [e.target.id]: e.target.value
        })
      }






    render() {
        const { auth } = this.props;

        if (!auth.uid) return <Redirect to='/signin' />


        return (
            <Container className="chat-container" fluid>
                {/* Feedback Dialog */}
                {!this.props.profile.isCounselor?
                <Modal
                    show={this.state.showFeedback}

                    size="xl"

                    

                >
                    <Modal.Header  >
                        <Modal.Title >Your feedback of the Peer Counselling session : </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form noValidate validated={this.state.validated} onSubmit={this.handleSubmit} onChange={this.handleChange}>
                            
                        <Form.Group>
                                <Form.Control as="textarea" rows="5" size='lg' id='feedback'  required/>
                                <Form.Control.Feedback type="invalid">
                        Please provide Feedback
                        </Form.Control.Feedback>
                                
                                </Form.Group>
                                <Button type="submit">Submit</Button>

                        </Form>
                    </Modal.Body>
                    

                </Modal>
                :null
                }
                <Row lg={2} sm={1} xs={1}>

                    {this.props.profile.isCounselor ? (


                        <Col lg={5} sm={12} xs={12}>
                            <Container >



                                <>
                                    <Accordion defaultActiveKey="0">
                                        <Card className={'details-card'}>

                                            <Accordion.Toggle as={Card.Header} eventKey="0">
                                                <img src={images.ic_info} className={'viewAvatarItem'} alt=''>
                                                </img>
                                                Personal Information
                                                </Accordion.Toggle>
                                            <Accordion.Collapse eventKey="0">
                                                <Card.Body>{
                                                    this.state.currentPeerUser ?
                                                        this.renderUserDetails()


                                                        : null
                                                }</Card.Body>
                                            </Accordion.Collapse>
                                        </Card>
                                        <Card className={'details-card'}>
                                            <Accordion.Toggle as={Card.Header} eventKey="1">
                                                <img src={images.ic_description} className={'viewAvatarItem'} alt=''>
                                                </img>
                                                    Intake Form 1
                                                    </Accordion.Toggle>
                                            <Accordion.Collapse eventKey="1">
                                                <Card.Body>{
                                                    this.state.intakeformdetails ?
                                                        this.renderUserIntakeForm1()



                                                        : null
                                                }
                                                </Card.Body>
                                            </Accordion.Collapse>
                                        </Card>
                                    </Accordion>
                                </>


                            </Container>

                        </Col>
                    ) : null}




                    {/* ChatCard */}
                    <Col lg={this.props.profile.isCounselor ? 7 : 12} sm={12} xs={12} >
                        <Card className="chat-card">
                            <div className="body ">

                                {this.state.currentPeerUser ? (
                                    <>
                                        <div className='row justify-content-center'>
                                            <Col >
                                                <button className="btn btn-block" onClick={this.props.profile.isCounselor ? this.doEndSessionForCounselor : this.endSession}>End session</button>
                                            </Col>
                                            {this.props.profile.isCounselor ?
                                                <Col>

                                                    <Form>
                                                        <Form.Check
                                                            onClick={this.toggleshowform}
                                                            type={'CheckBox'}
                                                            id={`checkform3`}
                                                            label={`Ask User to Fill Intake Form 3 ?`}
                                                        />

                                                    </Form>
                                                </Col> : null}
                                        </div>

                                        <div className="viewBoard">

                                            <ChatBoard
                                                currentPeerUser={this.state.currentPeerUser}
                                                showToast={this.props.showToast}
                                                auth={this.state.auth}
                                            />


                                        </div>
                                    </>
                                ) : null}
                            </div>
                        </Card>
                    </Col>


                </Row>

                {/* Intake form 1  */}



                {/* Loading */}
                {this.state.isLoading ? (
                    <>
                        <div className="viewLoading">
                            <div className='row justify-content-center'>

                                <h4>Finding Peer</h4>

                                <ReactLoading
                                    type={'bubbles'}
                                    color={'#203152'}
                                    height={'4.5rem'}
                                    width={'4.5rem'}

                                ></ReactLoading>

                                {this.props.profile.isCounselor &&

                                    <button className="btn btn-block btn-stop" onClick={this.onStopSession}>Stop Counseling</button>
                                }
                            </div>






                        </div>
                        {/* Dialog confirm */}

                    </>

                ) : null}
                {this.state.isOpenDialogConfirmLogout ? (
                    <div className="viewCoverScreen">
                        {this.renderDialogConfirmLogout()}
                    </div>
                ) : null}
            </Container>
        )
    }

    renderDialogConfirmLogout = () => {
        return (
            <div>
                <div className="viewWrapTextDialogConfirmLogout">
                    <span className="titleDialogConfirmLogout">Are you sure you want to end this session?</span>
                </div>
                <div className="viewWrapButtonDialogConfirmLogout">
                    <button className="btnYes" onClick={this.doStopSession}>
                        YES
                    </button>
                    <button className="btnNo" onClick={this.hideDialogConfirmLogout}>
                        CANCEL
                    </button>
                </div>
            </div>
        )
    }

}
const mapStateToProps = (state) => {
    return {
        auth: state.firebase.auth,
        profile: state.firebase.profile

    }
}


export default connect(mapStateToProps)(PeerChat)
// class PeerChat extends Component {



//     render() {
//         const {  auth } = this.props;
//         // const { dispatch, userMessage, messages } = this.props;

//         if (auth.uid == null) return <Redirect to='/signin' />
//         return (
//             <Container fluid className='justify-content-center chat-container'>
//                 <Card className='chat-card'>
//                     <Container style={{width:'10rem',height:'35rem'}}>

//                     </Container>
//                     <InputGroup className="mb-3">
//     <FormControl
//       placeholder="Enter Message to Send"
//       aria-label="Recipient's username"
//       aria-describedby="basic-addon2"
//     />
//     <InputGroup.Append>
//     <Button>Send</Button>

//     </InputGroup.Append>
//   </InputGroup>
//                 </Card>
//             </Container>
//         )
//     }
// }

// const mapStateToProps = (state) => {
//     return {
//         authError: state.auth.authError,
//         auth: state.firebase.auth,
//         userMessage: state.userMessage,
//         messages: state.messages
//     }
// }



// export default connect(mapStateToProps)(PeerChat)